const errors = {
  'invalid-items': {
    message: 'Você possui produtos não compatíveis para o Order Bump. Por favor, altere esses produtos antes de salvar'
  }
};

export default function getOrderBumpErrorMessages(type: 'invalid-items') {
  return errors[type]?.message || 'Ocorreu um erro com seu Order Bump. Tente novamente mais tarde';
}
